import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { SubscripeSharedDataService } from '../../services/subscripe-shared-data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  languagesItems: MenuItem[] = []
  isSubscribed: boolean = false

  constructor(public translate: TranslateService, private subscripeSharedDataService: SubscripeSharedDataService, public router: Router) { }

  ngOnInit() {
    this.languagesItems = [
      {
        label: 'العربية',
        code: 'ar'
      },
      {
        label: 'English',
        code: 'en'
      },
    ];

    this.subscripeSharedDataService.isSubscribed.subscribe(val => {
      this.isSubscribed = val
    })
  }

  switchLanguage() {
    if (this.translate.currentLang == 'en') {
      this.translate.use('ar')
      localStorage.setItem('Hidaya_lang', 'ar')
    } else {
      this.translate.use('en')
      localStorage.setItem('Hidaya_lang', 'en')
    }
  }

}
